import Navbar from './components/Navbar';

const App = () => (
  <>
    <Navbar />
  </>
);

export default App;
